import {styled} from '@mui/material/styles';

export const ContainerStyled = styled('div')(({theme}) => ({
  position: 'relative',
  overflow: 'hidden',
  height: '100%',
  '&.reorder-desk': {
    width: theme.spacing(5)
  },
  '&.reorder-mobile': {
    width: theme.spacing(4)
  },
  '&.promotion-image': {
    height: 48,
    width: 'auto'
  },
  '&.promotion-ribbons-pdp': {
    height: 40,
    width: 56
  },
  '&.right-ribbon': {
    width: 46,
    height: 32
  }
}));

export const StyledImage = styled('img')(() => ({
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  maxHeight: '180px',
  '&.right-ribbon': {
    objectFit: 'contain'
  },
  '&.product-card': {
    position: 'absolute'
  },
  '&.promotion': {
    position: 'absolute'
  }
}));

export const StyledSpan = styled('span')(() => ({
  paddingTop: '30px',
  display: 'block',
  '&.product-card': {
    paddingTop: '0'
  },
  '&.promotion': {
    paddingTop: '0'
  },
  '&.right-ribbon': {
    display: 'inline'
  }
}));
